module.exports = __webpack_public_path__ + "0d17aeb57619386566528935a816fd79.svg";